import { Dispatch } from "redux";

import { modalsActionTypes } from "./modalsTypes";

export function setButtonBlock(value: boolean) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: modalsActionTypes.SET_BUTTON_BLOCK,
            payload: value
        })
    }
}

export function setWithdrawModal(value: boolean) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: modalsActionTypes.SET_WITHDRAW_MODAL,
            payload: value
        })
    }
}

export function setDepositModal(value: boolean) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: modalsActionTypes.SET_DEPOSIT_MODAL,
            payload: value
        })
    }
}

export function setTransactionModal(value: boolean) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: modalsActionTypes.SET_TRANSACTION_MODAL,
            payload: value
        })
    }
}

export function setInfoModal(value: boolean, msg: string) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: modalsActionTypes.SET_INFO_MODAL ,
            payload: value
        })
        dispatch({
            type: modalsActionTypes.SET_INFO_MODAL_MSG ,
            payload: msg
        })
    }
}


export function setHistoryModal(value: boolean) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: modalsActionTypes.SET_HISTORY_MODAL,
            payload: value
        })
    }
}

export function setPriceHistoryModal(value: boolean) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: modalsActionTypes.SET_PRICE_HISTORY_MODAL,
            payload: value
        })
    }
}

export function  setWarningRequestModal(value: boolean, request: 'sell' | 'buy' | null) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: modalsActionTypes.SET_WARNING_REQUEST_MODAL,
            payload: value
        })
        dispatch({ 
            type: modalsActionTypes.SET_REQUEST_TYPE,
            payload: request
        })
    }
}

export function setChangeDepositModal(value: boolean, request: 'sell' | 'buy' | null) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: modalsActionTypes.SET_CHANGE_DEPOSIT_MODAL,
            payload: value
        })
        dispatch({ 
            type: modalsActionTypes.SET_REQUEST_TYPE,
            payload: request
        })
    }
}


